// extracted by mini-css-extract-plugin
export default {"wrapper":"SwitcherTabBar_wrapper__PXbXm","tab":"SwitcherTabBar_tab__UT98+","tabActive":"SwitcherTabBar_tabActive__MfVBf"};